import { VStack, Divider, cssVar } from '@cad-arc';
import { LocationSection } from './components/location-section';
import { FR_HEADER_HEIGHT, FR_FOOTER_HEIGHT } from '../../fr-page-layout/constants';
import { FREventSummaryEntitiesAndReports } from '../fr-event-summary-entities-and-reports';
import { EVENT_SUMMARY_SECTION_WIDTH } from '../constants';

export function FrEventSummary({ height }: { height?: string } = {}) {
    return (
        <VStack
            w={EVENT_SUMMARY_SECTION_WIDTH}
            h={height ?? `calc(100vh - ${FR_HEADER_HEIGHT + FR_FOOTER_HEIGHT}px)`}
            justifyContent="flex-start"
            alignItems="center"
            borderLeftWidth="1px"
            borderLeftColor="border.default"
            bgColor="surface.background"
            overflowY="auto"
            paddingBottom={cssVar('arc.space.6')}
            style={{ marginLeft: 0 }}
            data-testid="fr-assigned-event-summary"
        >
            <LocationSection />
            <Divider />
            <FREventSummaryEntitiesAndReports
                customStyles={{
                    padding: `${cssVar('arc.space.2')} ${cssVar('arc.space.6')} 0`,
                }}
            />
        </VStack>
    );
}
